import { SwitchProps } from "@mui/material";
import { StyledSwitch } from "./Switch.style";

const SwitchComponent = (props: SwitchProps) => <StyledSwitch {...props} />;

export default SwitchComponent;
